import { Schema as S } from "effect";
export const Schema = S.TemplateLiteral(S.Literal("cs_"), S.String).pipe(S.annotations({
    identifier: "@open-revenue/schema/stripe/CheckoutSessionId",
    description: "The id of the checkout session in Stripe",
    examples: [
        "cs_live_1234567890"
    ]
}));
export const make = (priceId)=>S.decodeUnknown(Schema)(priceId);
export const makeUnsafe = (priceId)=>priceId;
